import sliderClasses from "@mui/material/Slider/sliderClasses";
import { typographyResponsive } from "../../styles/utils/typography.module";
import { stripUnit } from "../../styles/utils/utils";
export const MuiSliderTheme = (dt) => {
    const vPadding = (stripUnit(dt.size.medium) - stripUnit(dt.size.xSmall3) + 4) / 2;
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                paddingTop: `${vPadding}px`,
                paddingBottom: `${vPadding}px`,
                [`.${sliderClasses.valueLabel}`]: Object.assign(Object.assign({}, typographyResponsive(dt, "caption")), { display: "flex", flexDirection: "row", borderRadius: dt.brand.borderRadius.small, border: `${dt.brand.borderWidth.xSmall} solid ${dt.color.palette.neutrals[90]}`, padding: `${stripUnit(dt.inset.squish.medium.vertical) - stripUnit(dt.inset.squish.medium.vertical) / 4} ${dt.inset.squish.medium.horizontal}`, color: dt.color.onSurface.key, background: dt.color.surface.key, boxShadow: dt.elevation.level4 }),
                [`.${sliderClasses.rail}`]: {
                    opacity: 1,
                    borderWidth: 0,
                    height: dt.size.xSmall3,
                    backgroundColor: dt.color.surface.variant,
                    borderRadius: dt.borderRadius.pill,
                },
                [`&.${sliderClasses.vertical}`]: {
                    [`.${sliderClasses.rail}`]: {
                        top: 0,
                        height: "100%",
                    },
                    [`.${sliderClasses.markLabel}`]: {
                        transform: "translate(2rem,50%)",
                    },
                },
                [`.${sliderClasses.track}`]: {
                    opacity: 1,
                    borderWidth: 0,
                    height: dt.size.xSmall3,
                    backgroundColor: dt.color.primary.key,
                    borderRadius: dt.borderRadius.pill,
                },
                [`.${sliderClasses.thumb}`]: {
                    width: dt.size.medium,
                    height: dt.size.medium,
                    backgroundColor: "#fff",
                    boxShadow: dt.elevation.level1,
                    "&:hover, &.Mui-focusVisible": {
                        boxShadow: `0 0 0 ${(stripUnit(dt.size.xLarge4) - stripUnit(dt.size.medium)) / 2}px ${dt.cta.outlined.color.background.primary.hover}`,
                    },
                    "&.Mui-active": {
                        boxShadow: `0 0 0 ${(stripUnit(dt.size.xLarge5) - stripUnit(dt.size.medium)) / 2}px ${dt.cta.outlined.color.background.primary.pressed}`,
                    },
                    "&::before": {
                        backgroundColor: dt.color.primary.key,
                    },
                    [`&.${sliderClasses.thumbSizeSmall}`]: {
                        width: dt.size.xSmall,
                        height: dt.size.xSmall,
                    },
                },
                [`.${sliderClasses.mark}`]: {
                    width: dt.size.xSmall4,
                    height: dt.size.xSmall4,
                    backgroundColor: dt.color.onSurface.variant,
                    borderRadius: dt.borderRadius.pill,
                },
                [`.${sliderClasses.markLabel}`]: Object.assign(Object.assign({}, typographyResponsive(dt, "subtitle2.regular")), { opacity: dt.opacity[50], color: dt.color.onSurface.variant }),
                [`.${sliderClasses.markLabelActive}`]: Object.assign(Object.assign({}, typographyResponsive(dt, "subtitle2.regular")), { opacity: 1, color: dt.color.onSurface.key }),
                [`.${sliderClasses.mark}`]: {
                    opacity: dt.opacity.states.disabled.content,
                    backgroundColor: dt.color.onSurface.variant,
                    [`&.${sliderClasses.markActive}`]: {
                        opacity: dt.opacity.states.disabled.content,
                        backgroundColor: dt.color.onPrimary.key,
                    },
                },
                [`&.${sliderClasses.disabled}`]: {
                    [`.${sliderClasses.rail}`]: {
                        opacity: dt.opacity.states.focus,
                        backgroundColor: dt.color.onSurface.key,
                    },
                    [`.${sliderClasses.track}`]: {
                        backgroundColor: dt.color.surface.key,
                        "&::before": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            width: "100%",
                            left: 0,
                            height: "100%",
                            opacity: dt.opacity.states.disabled.content,
                            backgroundColor: dt.color.onSurface.key,
                        },
                    },
                    [`.${sliderClasses.thumb}`]: {
                        backgroundColor: dt.color.surface.key,
                        "&::before": {
                            opacity: dt.opacity.states.disabled.content,
                            backgroundColor: dt.color.onSurface.key,
                        },
                    },
                    [`.${sliderClasses.mark}.${sliderClasses.markActive}`]: {
                        backgroundColor: dt.color.onSurface.key,
                    },
                    [`.${sliderClasses.markLabelActive}`]: {
                        opacity: dt.opacity[50],
                        color: dt.color.onSurface.variant,
                    },
                },
                [`&.${sliderClasses.trackInverted}`]: {
                    [`.${sliderClasses.rail}`]: {
                        opacity: 1,
                        borderWidth: 0,
                        height: dt.size.xSmall3,
                        backgroundColor: dt.color.primary.key,
                        borderRadius: dt.borderRadius.pill,
                    },
                    [`.${sliderClasses.track}`]: {
                        opacity: 1,
                        borderWidth: 0,
                        height: dt.size.xSmall3,
                        backgroundColor: dt.color.surface.variant,
                        borderRadius: dt.borderRadius.pill,
                    },
                    [`&.${sliderClasses.disabled}`]: {
                        [`.${sliderClasses.rail}`]: {
                            opacity: 1,
                            backgroundColor: dt.color.background.key,
                            "&::before": {
                                content: '""',
                                position: "absolute",
                                top: 0,
                                width: "100%",
                                left: 0,
                                height: "100%",
                                opacity: dt.opacity.states.disabled.content,
                                backgroundColor: dt.color.onSurface.key,
                            },
                        },
                        [`.${sliderClasses.track}`]: {
                            opacity: 1,
                            backgroundColor: dt.color.background.key,
                            "&::before": {
                                opacity: dt.opacity.states.focus,
                                backgroundColor: dt.color.onSurface.key,
                            },
                        },
                    },
                },
            },
        },
    };
};
